import { NumberCellEditor } from "./number-cell-editor";

export class AllocationNumberCellEditor extends NumberCellEditor {
    constructor(props) {
        super(props);

        if (!/^\d+?$/.test(this.state.value)) {
            this.state = {
                ...this.state,
                value: "",
            };
        }

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = (event) => {
        if (event.target.value === "" || /^\d+$/.test(event.target.value)) {
            this.setState({ value: event.target.value });
        }
    };
}
